<template>
  <div class="fcc-template-email">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :status="status"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
            :actions="actions"
            addFilter
            :items="listarTemplates"
          >
          </fccTable>
        </div>
      </div>
    </div>

    <fccModal
      :idModal="'modal-edit' + _uid"
      :titleModal="titleModal"
      size="lg"
      centered
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="submitTemplate()" autocomplete="off">
        <div class="position-relative mb-4">
          <fccInput extraClasses="inputLabel" v-model="editarTemplate.identificacao" required
            >Identificação</fccInput
          >
        </div>

        <fcc-code-editor
          label="Template do e-mail"
          v-model="editarTemplate.templatetext"
          lang="html"
        />

        <div class="row mt-2 mb-4">
          <div class="col">
            <fcc-button
              icon="eye"
              title="Pré-visualizar o template"
              v-b-tooltip.hover
              :action="() => viewField(null, editarTemplate)"
            />
          </div>

          <div class="col text-right">
            <toggle-button v-model="editarTemplate.ativo" />
            <label class="ml-2 h4">Ativo</label>
          </div>
        </div>

        <fcc-button classeAdd="w-100" tipo="submit">{{ labelsSystem.salvar }}</fcc-button>
      </form>
    </fccModal>

    <fccModal
      :idModal="'modal-view' + _uid"
      titleModal="Visualização do template"
      size="lg"
      centered
      escondeFooter
    >
      <span v-html="editarTemplate.templatetext"></span>
    </fccModal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import fccCodeEditor from '@/fccComponents/fccCodeEditor/fccCodeEditor.vue'

export default {
  components: { fccCodeEditor },
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Templates de Emails',
      titleModal: '',
      titlePDF: 'Templates de Emails',
      listarTemplates: [],
      editarTemplate: {},
      baseUrl: store.state.baseUrlEmails,
      itemPorPage: '100',
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        },
        {
          button: true,
          funcaoButton: 'viewField',
          icon: 'eye',
          tooltip: 'Visualizar Template',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'ativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fields: [
        { key: 'idtemplate', label: 'ID', sortable: true, active: true },
        {
          key: 'identificacao',
          label: 'Identificação',
          thClass: 'w-50',
          sortable: true,
          active: true
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    addTemplateEmail() {
      this.carregaTexto(this.codeMensagem('C03'))

      axios
        .post(
          this.baseUrl + 'Template/Inserir',
          this.editarTemplate,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listTemplateEmail()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'modal-edit' + this._uid)
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editTemplateEmail() {
      this.carregaTexto(this.codeMensagem('C05'))

      axios
        .put(
          this.baseUrl + 'Template/Alterar',
          this.editarTemplate,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listTemplateEmail()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'modal-edit' + this._uid)
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    submitTemplate() {
      if (this.editarTemplate.idtemplate === 0) {
        this.addTemplateEmail()
      } else {
        this.editTemplateEmail()
      }
    },
    listTemplateEmail: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrl + 'Template/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listarTemplates = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    changeStatus(_, item) {
      this.editarTemplate = item
      this.editTemplateEmail()
    },
    viewField(_, item) {
      this.editarTemplate = item
      this.$root.$emit('bv::show::modal', 'modal-view' + this._uid)
    },
    addField() {
      this.titleModal = 'Adicionar Template'
      this.editarTemplate = {
        idtemplate: 0,
        templatetext: '',
        ativo: true
      }
      this.$root.$emit('bv::show::modal', 'modal-edit' + this._uid)
    },
    editField(_, item) {
      this.titleModal = 'Editar Template'
      this.editarTemplate = { ...item }
      this.$root.$emit('bv::show::modal', 'modal-edit' + this._uid)
    },
    deleteField(_, item) {
      this.callConfirm(this.mensagemExcluir + '?', 'Template: ' + item.identificacao).then(
        (result) => {
          if (result.value) {
            this.carregaTexto(this.codeMensagem('C02'))

            axios
              .delete(
                this.baseUrl + 'Template/Excluir/' + item.idtemplate,
                this.dadosLoginSession.fccTokenHeaders
              )
              .then(() => {
                this.listarTemplates = this.listarTemplates.filter(
                  (temp) => temp.idtemplate !== item.idtemplate
                )
                this.callToast(this.mensagensUpdate.excluido, 'success')
              })
              .catch(this.setErrorSystem)
              .finally(this.carregaTexto)
          }
        }
      )
    }
  },
  mounted() {
    this.listTemplateEmail()
  }
}
</script>
